import { TruckImplementJourney } from 'app/modules/dashboards/dashboard-truck-implement/components/truck-implement-journey-tab/TruckImplementJourney';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import React from 'react';
import { Switch } from 'react-router-dom';

export const ChecklistFacilAsset = ({ match }) => (
  <div style={{ backgroundColor: '#FFFFFF', padding: '20px 30px', marginBottom: '20px' }}>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:id`} component={TruckImplementJourney} />
    </Switch>
  </div>
);
